import { Card, CircleUserIcon, Skeleton } from '@execonline-inc/execonline-ui';

function RecentActivitySkeleton() {
  return (
    <>
      <Skeleton variant="text" className="h-5 flex w-16 mb-4 mt-7 mr-4" />
      <Card className="bg-white w-full pt-7 px-6 pb-4" radius="lg">
        {[...Array(10)].map((_, index) => (
          <div key={index} className="flex items-center mb-8">
            <CircleUserIcon color="gray" className="mr-2 me-4 text-[2.25rem]" />
            <div className="w-[90%]">
              <Skeleton variant="text" className="h-3 mb-2" />
              <Skeleton variant="text" className="h-2 w-1/3" />
            </div>
          </div>
        ))}
      </Card>
    </>
  );
}

export default RecentActivitySkeleton;
